
import { EMPTY_LET_PASS_ACCOUNT_ENTITY, LetPassAccountEntity } from "domain/entity/LetPassAccount/LetPassAccountEntity";
import { EMPTY_LET_PASS_ACCOUNT_SEARCH_CRITERIA, LetPassAccountSearchCriteria } from "domain/entity/LetPassAccount/LetPassAccountSearchCriteria";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface LetPassAccountDropdownOptions {
    companyCodeDropdownOptions: DropdownProps[],
    bankCodeDropdownOptions: DropdownProps[],
    paymentModeDropdownOptions: DropdownProps[],
}

export interface LetPassAccountViewChangeState extends BaseViewChangeSate {
}
export interface LetPassAccountModel {
    isLoading: boolean,
    letPassAccountList: LetPassAccountEntity[],
    isShowEditPanel: boolean,
    isEdit: boolean,
    isAdd: boolean,
    selectedRows: LetPassAccountEntity[],
    currentRow: LetPassAccountEntity,
    currentEditRow: LetPassAccountEntity,
    searchCriteria: LetPassAccountSearchCriteria,
    dynamicOptions: LetPassAccountDropdownOptions,
    isShowSearchPanel: boolean,
    forceRefresh: boolean,
    lpaBanlance: number,
    masterState: LetPassAccountViewChangeState,

}

export const EMPTY_LET_PASS_ACCOUNT_MODEL: LetPassAccountModel = {
    isLoading: false,
    letPassAccountList: [],
    isShowEditPanel: false,
    isEdit: false,
    isAdd: false,
    selectedRows: [],
    currentRow: { ...EMPTY_LET_PASS_ACCOUNT_ENTITY },
    currentEditRow: { ...EMPTY_LET_PASS_ACCOUNT_ENTITY },
    searchCriteria: { ...EMPTY_LET_PASS_ACCOUNT_SEARCH_CRITERIA },
    dynamicOptions: {
        companyCodeDropdownOptions: [],
        bankCodeDropdownOptions: [],
        paymentModeDropdownOptions: []
    },
    isShowSearchPanel: false,
    forceRefresh: false,
    lpaBanlance: 0,
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}